/**
 * A identidade do contexto ativo, em texto — a chave que carimba tudo o que a aba guarda.
 *
 * Cache do lado da tela que não sabe a que contexto pertence mostra o dado do contexto
 * anterior depois da troca. Guardar a chave junto do dado faz a leitura recusar sozinha o
 * que não é do contexto de agora, sem depender de alguém lembrar de apagar.
 */

import { useManifestoStore } from './manifestoStore';
import type { ContextoAtivo } from '../types/manifesto';

/** Ausente enquanto o manifesto não chegou: sem contexto, nada é do contexto. */
export type ChaveDoContexto = string | null;

export function chaveDoContexto(contexto: ContextoAtivo | undefined): ChaveDoContexto {
  if (!contexto) return null;
  return `${contexto.tipo}:${contexto.id ?? ''}`;
}

export function useChaveDoContexto(): ChaveDoContexto {
  return useManifestoStore((estado) => chaveDoContexto(estado.manifesto?.contextoAtivo));
}
